// TODO: MAX CLASS
import { Handler } from './Utils';

export interface ValidationError {
  message: string;
}

export interface IDispatcher {
  onChange(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
  ): void;

  onBlur(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
    action?: string,
  ): void;

  onBlurMultiple(
    props: {
      id: string;
      value: any;
      valid: boolean;
      error: ValidationError | undefined;
      action?: string;
    }[],
  ): void;

  // TODO функция должна обновлять существующие значения (не перезаписывать все как onBlur) и должна добавлять новые значения, если их не было
  // onAddOrUpdateValues(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
  onVisit(id: string);

  onLoadFile(id: string, state: object): void;

  onAddValueRefresh(id: string, value: any, error: ValidationError | undefined);

  bind(name: string, handler: Handler): Handler;

  setError(
    id: string,
    value: any,
    error: { message } | undefined,
    skipCommonValidation: boolean,
  ): void;

  pullValue(control_id: string): any;
  notify(message: string): void;
  confirm(message: string, accept: any, header?: string): void;
  setErrors(errors: any): void;
  pullControlSchema(control_id: string): any;
  pullTableRows(control_id: string, field_id: string): Array<string>;
  gridRefreshValue?(controlId): void;

  setDynamicOption?({ selectType, options }): void;
  onUpdateForm?(): void;
}

export abstract class Dispatcher implements IDispatcher {
  abstract onAddValueRefresh(
    id: string,
    value: any,
    error: ValidationError | undefined,
  ): void;

  abstract onChange(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
  ): void;

  abstract onBlur(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
    action: string,
  ): void;

  abstract onBlurMultiple(
    props: {
      id: string;
      value: any;
      valid: boolean;
      error: ValidationError | undefined;
      action?: string;
    }[],
  ): void;

  // abstract onAddOrUpdateValues(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;

  abstract onVisit(id: string);

  abstract setError(
    id: string,
    value: any,
    error: { message } | undefined,
    skipCommonValidation: boolean,
  ): void;

  abstract onLoadFile(id: string, state: object): void;

  private events: { [name: string]: Handler[] } = {};

  bind(name: string, handler: Handler): Handler {
    let event = this.events[name];
    if (event === undefined) {
      event = [];
      this.events[name] = event;
    }

    event.push(handler);

    return function () {
      const i = event.indexOf(handler);
      event = event.splice(i, 1);
      this.events[name] = event;
    };
  }

  public invoke(name: string, ...args: any[]) {
    // eslint-disable-next-line no-restricted-syntax
    for (const ev of this.events[name]) {
      ev(...args);
    }
  }

  abstract pullValue(control_id: string): any;

  abstract notify(message: string): void;

  abstract confirm(message: string, accept: any, header?: string): void;

  abstract setErrors(errors: any): void;

  abstract pullControlSchema(control_id: string): any;

  abstract pullTableRows(control_id: string, field_id: string): Array<string>;

  setDynamicOption?({ selectType, options }): void;

  onUpdateForm?(): void;
}

export class ControlValueDispatcher extends Dispatcher {
  public controlVisited: (id: string) => void;

  addControlRefres: any;

  public addControlValue: (
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
    opts?: any,
    action?: string,
  ) => void;

  public addMultipleControlValues: (
    props: {
      id: string;
      value: any;
      valid: boolean;
      error: ValidationError | undefined;
      action?: string;
    }[],
  ) => void;

  // public addOrUpdateValues: (id:string, value:any, valid:boolean, error: ValidationError | undefined) => void;

  public addControlRefresh: (
    id: string,
    value: any,
    error: ValidationError | undefined,
  ) => void;

  public gridRefreshValue: (controlId: string) => void;

  public copyValue: (source: string, target: string) => void;

  public addFile: (id: string, state: object) => void;

  public error: (
    id: string,
    value: any,
    error: ValidationError | undefined,
    skipCommonValidation: boolean,
  ) => void;

  setDynamicOption: ({ selectType, options }) => void;

  onUpdateForm: () => void;

  onVisit(id: string) {
    this.controlVisited(id);
  }

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars
  onChange(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  ): void {}

  onBlur(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError,
    opts?: any,
    action?: string,
  ): void {
    this.addControlValue(id, value, valid, error, opts, action);
  }

  onBlurMultiple(
    props: {
      id: string;
      value: any;
      valid: boolean;
      error: ValidationError | undefined;
      action?: string;
    }[],
  ): void {
    this.addMultipleControlValues(props);
  }

  // onAddOrUpdateValues(id: string, value: any, valid: boolean, error: ValidationError): void {
  //     this.addOrUpdateValues(id, value, valid, error);
  // }

  onLoadFile(id: string, state: object) {
    this.addFile(id, state);
  }

  onAddValueRefresh(
    id: string,
    value: any,
    error: ValidationError | undefined,
  ): void {
    this.addControlRefresh(id, value, error);
  }

  onGridRefreshValue(controlId: string): void {
    this.gridRefreshValue(controlId);
  }

  setError(
    id: string,
    value: any,
    error: { message } | undefined,
    skipCommonValidation = false,
  ): void {
    this.error(id, value, error, skipCommonValidation);
  }

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  pullValue(control_id: string): any {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  notify(message: string): void {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  confirm(message: string, accept: any, header?: string): void {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  setErrors(errors: any): void {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  pullControlSchema(control_id: string): any {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars
  pullTableRows(control_id: string, field_id: string): Array<string> {
    return [];
  }
}
